const fontFamilyOptions = [
    {
        id: 'montserrat',
        label: 'Montserrat',
        exampleText: 'AaBbCc',
        type: 'Montserrat',
        default: false,
    },
    {
        id: 'poppins',
        label: 'Poppins',
        exampleText: 'AaBbCc',
        type: 'Poppins',
        default: false,
    },
    {
        id: 'raleway',
        label: 'Raleway',
        exampleText: 'AaBbCc',
        type: 'Raleway',
        default: false,
    },
    {
        id: 'arial',
        label: 'Arial',
        exampleText: 'AaBbCc',
        type: 'Arial',
        default: true,
    },
    // Finns bara i regular. Behöver bytas mot en font med bold och italic eller låsa ner bold/italic alternativen.
    // {
    //   id: 'monte-carlo',
    //   label: 'Monte Carlo',
    //   exampleText: 'AaBbCc',
    //   type: 'MonteCarlo',
    //   default: false,
    // },
    {
        id: 'merriweather',
        label: 'Merriweather',
        exampleText: 'AaBbCc',
        type: 'Merriweather',
        default: false,
    },
    {
        id: 'bodoni-moda',
        label: 'Bodoni Moda',
        exampleText: 'AaBbCc',
        type: 'Bodoni Moda',
        default: false,
    },
    {
        id: 'times-new-roman',
        label: 'Times New Roman',
        exampleText: 'AaBbCc',
        type: 'Times New Roman',
        default: false,
    },
];
export default fontFamilyOptions;
